import get from "lodash/get";
import React from "react";
import { useDeviceType } from "../../../customHooks/useDeviceType.js";
import { getStoryElementByType } from "../../../utils/index.js";
import "./powered-by.m.css";

const SponsorBox = ({ hyperLink, title, cdnImage, element }) => {
  const imageUrl = `${cdnImage}/${element?.["image-s3-key"]}`;

  return (
    <div styleName="sponsor-box">
      <span dangerouslySetInnerHTML={{ __html: title }} />
      {hyperLink ? (
        <a href={hyperLink} target="_blank" rel="nofollow noopener noreferrer">
          <img src={imageUrl} alt="Logo" styleName="client-logo" />
        </a>
      ) : (
        <img src={imageUrl} alt="Logo" styleName="client-logo" />
      )}
    </div>
  );
};

const PoweredBy = ({ card, cdnImage }) => {
  const logoCarouselTitle = getStoryElementByType(card, "title");
  const logoCarouselLogos = getStoryElementByType(card, "composite");
  const isMobile = useDeviceType("desktop") !== "desktop";
  const mobileCarousel =
    logoCarouselLogos?.["story-elements"]?.length < 3 ? (
      <div styleName="client-logo-wrapper">
        {logoCarouselLogos?.["story-elements"]?.map((element) => {
          const hyperLink = get(element, ["hyperlink"], "");
          const title = get(element, ["title"], "");
          return <SponsorBox hyperLink={hyperLink} title={title} cdnImage={cdnImage} element={element} />;
        })}
      </div>
    ) : (
      <marquee>
        <div styleName="client-logo-wrapper">
          {logoCarouselLogos?.["story-elements"]?.map((element) => {
            const hyperLink = get(element, ["hyperlink"], "");
            const title = get(element, ["title"], "");
            return <SponsorBox hyperLink={hyperLink} title={title} cdnImage={cdnImage} element={element} />;
          })}
        </div>
      </marquee>
    );

  const desktopCarousel =
    logoCarouselLogos?.["story-elements"]?.length < 5 ? (
      <div styleName="client-logo-wrapper">
        {logoCarouselLogos?.["story-elements"]?.map((element) => {
          const hyperLink = get(element, ["hyperlink"], "");
          const title = get(element, ["title"], "");
          return <SponsorBox hyperLink={hyperLink} title={title} cdnImage={cdnImage} element={element} />;
        })}{" "}
      </div>
    ) : (
      <marquee>
        <div styleName="client-logo-wrapper">
          {logoCarouselLogos?.["story-elements"]?.map((element) => {
            const hyperLink = get(element, ["hyperlink"], "");
            const title = get(element, ["title"], "");
            return <SponsorBox hyperLink={hyperLink} title={title} cdnImage={cdnImage} element={element} />;
          })}
        </div>
      </marquee>
    );

  const id = get(card, ["metadata", "attributes", "menuname", "0"], "");
  return logoCarouselLogos ? (
    <div className="powered-by-container" styleName="powered-by-container" id={`${id.toLowerCase()}`}>
      <div styleName="frame">
        <div styleName="text-wrapper">{logoCarouselTitle?.text}</div>
        {isMobile && mobileCarousel}
        {!isMobile && desktopCarousel}
      </div>
    </div>
  ) : null;
};

export default PoweredBy;
